import { Instance, SnapshotIn, types } from 'mobx-state-tree';

// ========================================
// Single Key

export interface SingleKeyProps {
  clientId?: string;
  clientSecret?: string;
}

export const SingleKey = types.model({
  clientId: types.maybe(types.string),
  clientSecret: types.maybe(types.string),
});

export type SingleKeySnapshot = SnapshotIn<typeof SingleKey>;
export type SingleKeyInstance = Instance<typeof SingleKey>;

// ========================================
// Key Set

export interface KeySetProps {
  sandbox?: SingleKeyProps;
  production?: SingleKeyProps;
}

export const KeySet = types.model({
  sandbox: types.optional(SingleKey, {}),
  production: types.optional(SingleKey, {}),
});

export type KeySetSnapshot = SnapshotIn<typeof SingleKey>;
export type KeySetInstance = Instance<typeof SingleKey>;
